import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DashboardControllerApi } from "../../fetcher";
import { HOME_PATH } from "../../utils/Contants";
import { genApiConfig } from "../../utils/fetch-caller";
import { getArgsQuery } from "../../utils/GlobalFunction";
import { getConfig } from "../../config/runtimeConfig";

const ErrorPage = (props: any, state: any) => {
    // const errorCode = getArgsQuery();
    // console.log("ErrorPage1", errorCode);
    console.log("wwww", window.location);

    const navigate = useNavigate();

    useEffect(() => {
        const config = getConfig();
        fetch(`${config.BACKEND2 || config.BACKEND}/dashboard/checkstatus`).then((res) => {
            console.log("res", res);
        });
    }, []);

    return <div style={{ fontSize: "30px" }}>ErrorPage </div>;
};

export default ErrorPage;
